import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

/**
 * Tipi di layout del footer disponibili
 */
export type FooterLayout = "full" | "minimal";

export type FooterBackground = "white" | "transparent";

/**
 * Servizio per gestire il layout del footer
 * Le pagine possono comunicare il tipo di footer desiderato
 */
@Injectable({ providedIn: "root" })
export class ApeFooterService {
  private footerLayoutSubject = new BehaviorSubject<FooterLayout>("minimal");

  private footerBackgroundSubject = new BehaviorSubject<FooterBackground>("transparent");

  /**
   * Observable che emette il layout corrente del footer
   */
  public footerLayout$ = this.footerLayoutSubject.asObservable();

  /**
   * Observable che emette il background corrente del footer
   */
  public footerBackground$ = this.footerBackgroundSubject.asObservable();

  /**
   * Getter per ottenere il layout corrente del footer
   * @returns Il layout corrente del footer
   */
  get currentLayout(): FooterLayout {
    return this.footerLayoutSubject.value;
  }

  /**
   * Getter per ottenere il background corrente del footer
   * @returns Il background corrente del footer
   */
  get currentBackground(): FooterBackground {
    return this.footerBackgroundSubject.value;
  }

  /**
   * Imposta il layout del footer
   * @param layout Il tipo di layout desiderato
   */
  setFooterLayout(layout: FooterLayout): void {
    this.footerLayoutSubject.next(layout);
  }

  /**
   * Imposta il background del footer
   * @param background Il tipo di background desiderato
   */
  setFooterBackground(background: FooterBackground): void {
    this.footerBackgroundSubject.next(background);
  }

  /**
   * Resetta il footer al layout minimale (default)
   */
  resetToMinimal(): void {
    this.footerLayoutSubject.next("minimal");
  }

  /**
   * Resetta il footer al background trasparente (default)
   */
  resetToTransparent(): void {
    this.footerBackgroundSubject.next("transparent");
  }

  /**
   * Resetta il footer alle impostazioni di default
   */
  resetToDefault(): void {
    this.resetToMinimal();
    this.resetToTransparent();
  }
}
